module.exports = __webpack_public_path__ + "static/media/ic_no_student.83d62082.svg";